import { useMutation, useQuery } from '@apollo/client';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useChatSession } from '~/modules';

import {
  INTAKE_TACTICAL_SOURCING_SKIP_MUTATION,
  INTAKE_TACTICAL_SOURCING_START_MUTATION,
} from './IntakeTacticalSourcingSelectionStep.mutation.gql';
import { INTAKE_TACTICAL_SOURCING_SELECTION } from './IntakeTacticalSourcingSelectionStep.query.gql';

export const IntakeTacticalSourcingSelectionStep = ({ role, createdBy, isCompleted }: ChatMessageProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeTacticalSourcingSelectionStep' });
  const session = useChatSession();

  // TODO: Make sure to use the data for showing the buttons
  const { loading } = useQuery(INTAKE_TACTICAL_SOURCING_SELECTION, {
    variables: session,
  });

  const [skip] = useMutation(INTAKE_TACTICAL_SOURCING_SKIP_MUTATION, {
    variables: { data: { chatSessionId: session.id } },
    refetchQueries: [{ query: INTAKE_TACTICAL_SOURCING_SELECTION, variables: session }],
  });
  const [start] = useMutation(INTAKE_TACTICAL_SOURCING_START_MUTATION, {
    variables: { data: { chatSessionId: session.id } },
    refetchQueries: [{ query: INTAKE_TACTICAL_SOURCING_SELECTION, variables: session }],
  });

  const disabled = isCompleted || loading;

  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message')}
      footer={
        <Stack direction="row" spacing={2}>
          <Button
            disabled={disabled}
            variant="contained"
            color="primary"
            onClick={() => {
              start();
            }}
          >
            {t('button.start')}
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              skip();
            }}
          >
            {t('button.skip')}
          </Button>
        </Stack>
      }
    />
  );
};
